export enum DriverTypes {
  GET_DRIVER = 'GET_DRIVER',
  SET_REFUSED_DATAS = 'SET_REFUSED_DATAS',
  SET_REFUSED_DATAS_DRAFT = 'SET_REFUSED_DATAS_DRAFT',
  SET_CLEAR_ALL_REFUSED_DATAS = 'SET_CLEAR_ALL_REFUSED_DATAS',
}

export interface InitialDriver {
  driverId: string;
  username: string;
  email: string;
  cpf: string;
  rg: string;
  phoneNumber: string;
  birthDate: string;
  resetPasswordToken: string;
  resetPasswordSentAt: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  selfie: string;
  imageUrl: string;
  driverLicense: DriverLicense;
  vehicle: {
    vehicleId: string;
    model: string;
    year: string;
    plate: string;
    weight: string;
    payloadCapacity: string;
    length: string;
    width: string;
    frontVehicle: string;
    backVehicle: string;
    leftVehicle: string;
    rightVehicle: string;
    createdAt: string;
    updatedAt: string;
    crlv: {
      imageUrl: string;
    };
    vehicleType: {
      vehicleType: string;
    };
  };
  freight: [
    {
      freightId: string;
      freightCost: number;
      totalKilometers: number;
      numberOfHelpers: number;
      deliveryLimitDate: string;
      freightStatus: string;
      vehicleTypePrice: number;
      totalWeight: number;
      pickUpDate: string;
      acceptDate: string;
      createdAt: string;
      updatedAt: string;
      deliveries: [
        {
          loadNumbers: string;
          orders: [
            {
              numberOfOrders: number;
            },
          ];
        },
      ];
    },
  ];
  refusedData: Array<IRefusedData>;
  reasonsRefusalDraft: Array<IReasonRefusalDraft>;
}

export interface DriverLicense {
  length: string;
  driverLicenseId: string;
  driverLicenseNumber?: string;
  driverLicenseExpiryDate?: string;
  front: string;
  back: string;
  selfie: string;
  categories?: string[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface IReasonRefusal {
  reasonRefusalId: {
    reasonRefusalId: string;
    reason: string;
    description: string;
    createdAt: string;
    updatedAt: string;
  };
  step: number;
  refusedDataId: string;
}

export interface IRefusedData {
  refusedDataId: string;
  step: number;
  reason: IReasonRefusal;
  createdAt: Date;
  updatedAt: Date;
}

export interface IReasonRefusalDraft {
  reasonRefusalId: string;
  step: number;
  refusedDataId: string;
}
